var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6546 19.7154L13.5861 2.25926C12.714 0.580248 11.2862 0.580248 10.4141 2.25926L1.34527 19.7154C0.473245 21.3944 1.31079 22.7684 3.20725 22.7684H20.7926C22.6891 22.7684 23.527 21.3944 22.6546 19.7154ZM10.8969 7.61125C10.8969 7.00402 11.3906 6.51128 11.9999 6.51128C12.6092 6.51128 13.1037 7.00436 13.1037 7.61125V15.0391C13.1037 15.6463 12.6092 16.139 11.9999 16.139C11.3906 16.139 10.8969 15.646 10.8969 15.0391V7.61125ZM11.9999 20.3336C11.2382 20.3336 10.6207 19.7185 10.6207 18.9582C10.6207 18.1987 11.2382 17.5828 11.9999 17.5828C12.7616 17.5828 13.3792 18.1987 13.3792 18.9582C13.3792 19.7185 12.7616 20.3336 11.9999 20.3336Z",
    fill: "#EE9D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.49e978a4e7ee0f16bead4a6e09e3c610.svg";
export { ForwardRef as ReactComponent };